import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Filters from "../../../components/filters/Filters";
import CsUserFilter from "./CsUserFilter";
//import DatePicker from "../../../components/DatePicker/DatePicker"; // Assuming a DatePicker component exists

// Define filter types, similar to ISSUE_FILTERS_TYPES
const NOT_LINKED_ITEMS_FILTERS_TYPES = {
  DATE_RANGE: "dateRange",
  CLIENT_SERVICE_USER: "clientServiceUser",
  SERIES_NAME_OR_CODE: "seriesNameOrCode",
  CLIENT_NAME: "clientName",
  WO_LINKED: "woLinked",
};

class NotLinkedItemsFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateFrom: props.dateFrom,
      dateTo: props.dateTo,
      clientServiceUser: [],
      seriesNameOrCode: "",
      clientName: [],
      woLinked: false,
    };

    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleApplyFilters = this.handleApplyFilters.bind(this);
  }


  handleChangeFilter = (name, value) => {
    if (name === NOT_LINKED_ITEMS_FILTERS_TYPES.DATE_RANGE) {
      this.setState({ dateFrom: value.start, dateTo: value.end });
    } else if (name === NOT_LINKED_ITEMS_FILTERS_TYPES.CLIENT_SERVICE_USER) {
      this.setState({ clientServiceUser: value });
    } else if (name === NOT_LINKED_ITEMS_FILTERS_TYPES.SERIES_NAME_OR_CODE) {
      this.setState({ seriesNameOrCode: value });
    } else if (name === NOT_LINKED_ITEMS_FILTERS_TYPES.CLIENT_NAME) {
      this.setState({ clientName: value });
    } else if (name === NOT_LINKED_ITEMS_FILTERS_TYPES.WO_LINKED) {
      this.setState({ woLinked: value });
    }
  };

  handleApplyFilters = () => {
    this.props.applyFilters({
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
      clientServiceUser: this.state.clientServiceUser,
      seriesNameOrCode: this.state.seriesNameOrCode,
      clientName: this.state.clientName,
      woLinked: this.state.woLinked,
    });
  };

  // Basic check, adjust if needed based on your state structure
  isAppliedUsedFilters = () => {
    const appliedUsedFiltersJson = {
      dateFrom: this.state.dateFrom,
      dateTo: this.state.dateTo,
      clientServiceUser: this.state.clientServiceUser,
      seriesNameOrCode: this.state.seriesNameOrCode,
      clientName: this.state.clientName,
      woLinked: this.state.woLinked,
    }
    const usedFilters = {
      dateFrom: this.props.dateFrom,
      dateTo: this.props.dateTo,
      clientServiceUser: this.props.clientServiceUser,
      seriesNameOrCode: this.props.seriesNameOrCode,
      clientName: this.props.clientName,
      woLinked: this.props.woLinked,
    }
    return JSON.stringify(appliedUsedFiltersJson) === JSON.stringify(usedFilters);
  };

  prepareFilters = () => {
    const { csUserList, clientList, notLinkedItems } = this.props;
    const { csUserLeaderboard } = notLinkedItems;
    const { clientServiceUser } = this.state; // Get selected users from state
    
    // Prepare CS User options (already correctly prepared for UserSelector's 'users' prop)
    const csUserOptions = csUserList.map(user => ({
      name: user.name || user,
      value: user.value || user,
    }));
    csUserOptions.push({
      name: 'Unknown User',
      value: '-1',
    });

    // Prepare Client options
    const clientOptions = clientList.map(client => ({
      name: client.name || client,
      value: client.value || client,
    }));

    const preparedFilters = [
      {
        name: NOT_LINKED_ITEMS_FILTERS_TYPES.DATE_RANGE,
        title: "Date",
        type: "date",
      },
      {
        name: NOT_LINKED_ITEMS_FILTERS_TYPES.CLIENT_SERVICE_USER,
        title: "Client Service User",
        type: "custom",
        field: (
          <CsUserFilter
            users={csUserOptions}
            leaderboard={csUserLeaderboard}
            selectedUserList={clientServiceUser}
            onChange={(selected) => this.handleChangeFilter(NOT_LINKED_ITEMS_FILTERS_TYPES.CLIENT_SERVICE_USER, selected)}
          />
        ),
      },
      {
        name: NOT_LINKED_ITEMS_FILTERS_TYPES.SERIES_NAME_OR_CODE,
        title: "Series Name or Code",
        type: "string",
      },
      {
        name: NOT_LINKED_ITEMS_FILTERS_TYPES.CLIENT_NAME,
        title: "Client Name",
        type: "select",
        values: clientOptions,
      },
      {
        name: NOT_LINKED_ITEMS_FILTERS_TYPES.WO_LINKED,
        title: "Include WO Linked Items",
        type: "bool",
      },
    ];

    return preparedFilters;
  };

  render() {
    const { notLinkedItems } = this.props; // Adjust to your reducer name
    const { loaders } = notLinkedItems; // Assuming loaders exist in your state
    const { dateFrom, dateTo } = this.state; // Get dateFrom and dateTo from local state
    const isShowRefreshBtn = this.isAppliedUsedFilters(); // Assuming similar logic for refresh/apply

    // A simplified version, assuming 'loaders.gettingData' or similar exists
    const isLoading = loaders && loaders.gettingNotLinkedItems;

    // Construct usedFilters object for the Filters component
    const usedFiltersForDisplay = {
      [NOT_LINKED_ITEMS_FILTERS_TYPES.DATE_RANGE]: {
        start: dateFrom,
        end: dateTo,
      },
      [NOT_LINKED_ITEMS_FILTERS_TYPES.CLIENT_SERVICE_USER]: this.state.clientServiceUser,
      [NOT_LINKED_ITEMS_FILTERS_TYPES.SERIES_NAME_OR_CODE]: this.state.seriesNameOrCode,
      [NOT_LINKED_ITEMS_FILTERS_TYPES.CLIENT_NAME]: this.state.clientName,
      [NOT_LINKED_ITEMS_FILTERS_TYPES.WO_LINKED]: this.state.woLinked,
    };

    return (
      <Filters
        loading={!!isLoading}
        filters={this.prepareFilters()}
        usedFilters={usedFiltersForDisplay} // Pass the constructed object
        onChange={this.handleChangeFilter}
        applyLabel={isShowRefreshBtn ? "Refresh" : "Apply"} // Assuming similar refresh logic
        applyFilters={this.handleApplyFilters} // Simplified, add refresh logic if needed
        isShowApplyBtnInHeaderWhenCollapsed
        title="Filters"
        bodyMd={12}
      />
    );
  }
}

NotLinkedItemsFilters.propTypes = {
  notLinkedItems: PropTypes.object.isRequired,
  applyFilters: PropTypes.func.isRequired,
  dateFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  dateTo: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  csUserList: PropTypes.array,
  clientList: PropTypes.array,
};

NotLinkedItemsFilters.defaultProps = {
  csUserList: [],
  clientList: [],
};

function mapStateToProps(state) {
  return {
    notLinkedItems: state.notLinkedItems, // Adjust to your reducer name
    //dateFrom: state.notLinkedItems.usedFilters[NOT_LINKED_ITEMS_FILTERS_TYPES.DATE_FROM],
    //dateTo: state.notLinkedItems.usedFilters[NOT_LINKED_ITEMS_FILTERS_TYPES.DATE_TO],
  };
}

export default connect(mapStateToProps)(NotLinkedItemsFilters);